import { OneStemBrand } from '@/components/brand/OneStemBrand'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { useAppForm } from '@/lib/form'
import { useForgotPasswordMutation } from '@/lib/services/auth/auth.query'
import { forgotPasswordSchema } from '@/lib/services/auth/auth.schema'
import { createFileRoute, Link, useCanGoBack, useRouter } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { toast } from 'sonner'

export const Route = createFileRoute('/(auth)/forgot-password')({
  component: RouteComponent,
  loader: () => ({ isReadOnly: false }),
})

function RouteComponent() {
  const router = useRouter()
  const canGoBack = useCanGoBack()
  const forgotPasswordMutation = useForgotPasswordMutation()

  const form = useAppForm({
    defaultValues: {
      email: '',
    },
    validators: {
      onSubmit: forgotPasswordSchema,
      onSubmitAsync: async ({ value }) => {
        try {
          await forgotPasswordMutation.mutateAsync(value, {
            onSuccess: () => {
              toast.success('Password reset link sent successfully')
            },
          })
        } catch (error) {
          if (error?.response?.data?.errors) {
            return { fields: error.response.data.errors }
          }
        }
      },
    },
  })

  return (
    <div className="flex flex-col gap-y-4 h-screen items-center justify-center px-8 sm:px-0">
      <Link to="/">
        <OneStemBrand className="h-20" />
      </Link>
      <Card className="w-full sm:max-w-md">
        <CardHeader>
          <CardTitle>Forgot your password?</CardTitle>
          <CardDescription>
            Enter your email address and we'll send you a password reset link
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form.AppForm>
            <form.Form>
              <div className="grid w-full items-center gap-y-6">
                <form.FormError />
                <form.AppField
                  name="email"
                  validators={{ onChange: forgotPasswordSchema.shape.email }}
                >
                  {(field) => <field.EmailInput label="Email" />}
                </form.AppField>
                <form.SubmitButton mutation={forgotPasswordMutation}>
                  Send Reset Link
                </form.SubmitButton>
              </div>
            </form.Form>
          </form.AppForm>
        </CardContent>
        <CardFooter className="flex flex-col gap-y-8 justify-between">
          {canGoBack && (
            <Button variant="ghost" onClick={() => router.history.back()} className="w-full">
              <ChevronLeft className="h-4 w-4" /> Back
            </Button>
          )}
        </CardFooter>
      </Card>
    </div>
  )
}
